import { Select } from 'antd';
import { useState } from 'react';
import camelCase from 'lodash/camelCase';
import {
  Icon,
  ICONS,
  Button,
  PLATFORM_THEME_COLORS,
  TreeSelectSearchInput,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { GanttViewsEnum } from 'src/pages/gantt/gantt.enums';
import { useSearchInGanttProjectsByCustomers } from 'src/hooks/projects/search-in-gantt-projects-by-customers.hook';

import { IGanttTopBarButtons } from './gantt-top-bar-buttons.interfaces';
import { SelectWrapper, ButtonsWrapper, ArrowButton } from './gantt-top-bar-buttons.styles';

const GanttTopBarButtons = ({
  ganttControl: { highlightProjectIds, view, weekendsActive, fullScreenActive },
  setGanttControl,
  onClickNextBtn,
  onClickPrevBtn,
  onTodayClickBtn,
  onFullScreenClickBtn,
}: IGanttTopBarButtons) => {
  const { t } = useTranslation(['common', 'gantt']);
  const onControlChange = (config: any) => setGanttControl(control => ({ ...control, ...config }));
  const [search, setSearch] = useState('');

  const { loading, projectsByCustomers } = useSearchInGanttProjectsByCustomers(search);
  const treeData = projectsByCustomers.map(({ customer, projects }: any) => ({
    label: customer.name,
    value: customer._id,
    children: projects.map((project: any) => ({ label: project.name, value: project._id })),
  }));

  return (
    <ButtonsWrapper>
      <TreeSelectSearchInput
        filterTreeNode={false}
        loading={loading}
        value={highlightProjectIds}
        searchValue={search}
        treeData={treeData}
        onSearch={searchValue => setSearch(searchValue)}
        onChange={highlightProjectIds => onControlChange({ highlightProjectIds })}
      />
      <Button type="ghost" icon={ICONS.expand} onClick={onFullScreenClickBtn}>
        {t('gantt:labels.fullSize')}
      </Button>
      <Button
        type="ghost"
        icon={weekendsActive ? ICONS.show : ICONS.hide}
        onClick={() => onControlChange({ weekendsActive: !weekendsActive })}
      >
        {t('gantt:labels.weekend')}
      </Button>

      <Button type="primary" onClick={onTodayClickBtn}>
        {t('gantt:labels.today')}
      </Button>
      <ArrowButton onClick={onClickPrevBtn}>
        <Icon
          icon={ICONS.chevronLeft}
          size={22}
          rightMargin={false}
          color={PLATFORM_THEME_COLORS.primary.blue}
        />
      </ArrowButton>
      <ArrowButton onClick={onClickNextBtn}>
        <Icon
          icon={ICONS.chevronRight}
          size={22}
          rightMargin={false}
          color={PLATFORM_THEME_COLORS.primary.blue}
        />
      </ArrowButton>

      <SelectWrapper>
        <Select
          getPopupContainer={(triggerNode: any) => triggerNode}
          defaultValue={view}
          onChange={value => onControlChange({ view: value })}
          suffixIcon={
            <Icon
              icon={ICONS.chevronDown}
              color={PLATFORM_THEME_COLORS.primary.blue}
              rightMargin={false}
            />
          }
        >
          {Object.values(GanttViewsEnum).map(view => (
            <Select.Option key={view} value={view}>
              {t(`common:labels.${camelCase(view)}`)}
            </Select.Option>
          ))}
        </Select>
      </SelectWrapper>
    </ButtonsWrapper>
  );
};

export default GanttTopBarButtons;
